import { all, takeEvery, put, fork, call, select } from 'redux-saga/effects';
import { message } from 'antd';
import actions from './actions';
import { ApiClient } from '../../../api';
import { makeSelectToken } from '../../auth/selector';
import config from '../../../settings';

// Create selector once for optimal performance
const selectToken = makeSelectToken();

function* getScopesSaga() {
  yield takeEvery(actions.GET_SCOPES, function*() {
    try {
      // Use idToken for Super Admin operations (scopes management)
      const idToken = yield select(selectToken);
      const apiClient = new ApiClient(config.apiUrl, idToken);
      const response = yield call(() => apiClient.getScopes());
      if (response.success) {
        yield put(actions.getScopesSuccess(response.data));
      } else {
        yield put(actions.getScopesError(response.message || 'Failed to fetch scopes'));
        message.error('Failed to fetch scopes');
      }
    } catch (error) {
      console.error('Error fetching scopes:', error);
      yield put(actions.getScopesError(error.message));
      message.error(`Error fetching scopes: ${error.message}`);
    }
  });
}

function* createScopeSaga() {
  yield takeEvery(actions.CREATE_SCOPE, function*({ scopeData }) {
    try {
      const idToken = yield select(selectToken);
      const apiClient = new ApiClient(config.apiUrl, idToken);
      const response = yield call(() => apiClient.createScope(scopeData));
      if (response.success) {
        yield put(actions.createScopeSuccess(response.data));
        message.success('Scope created successfully');
      } else {
        yield put(actions.createScopeError(response.message || 'Failed to create scope'));
        message.error('Failed to create scope');
      }
    } catch (error) {
      yield put(actions.createScopeError(error.message));
      message.error(`Error creating scope: ${error.message}`);
    }
  });
}

function* updateScopeSaga() {
  yield takeEvery(actions.UPDATE_SCOPE, function*({ scopeId, scopeData }) {
    try {
      const idToken = yield select(selectToken);
      const apiClient = new ApiClient(config.apiUrl, idToken);
      const response = yield call(() => apiClient.updateScope(scopeId, scopeData));
      if (response.success) {
        yield put(actions.updateScopeSuccess(response.data));
        message.success('Scope updated successfully');
      } else {
        yield put(actions.updateScopeError(response.message || 'Failed to update scope'));
        message.error('Failed to update scope');
      }
    } catch (error) {
      yield put(actions.updateScopeError(error.message));
      message.error(`Error updating scope: ${error.message}`);
    }
  });
}

function* deleteScopeSaga() {
  yield takeEvery(actions.DELETE_SCOPE, function*({ scopeId }) {
    try {
      const idToken = yield select(selectToken);
      const apiClient = new ApiClient(config.apiUrl, idToken);
      const response = yield call(() => apiClient.deleteScope(scopeId));
      if (response.success) {
        yield put(actions.deleteScopeSuccess(scopeId));
        message.success('Scope deleted successfully');
      } else {
        yield put(actions.deleteScopeError(response.message || 'Failed to delete scope'));
        message.error('Failed to delete scope');
      }
    } catch (error) {
      yield put(actions.deleteScopeError(error.message));
      message.error(`Error deleting scope: ${error.message}`);
    }
  });
}

export default function* scopesSaga() {
  yield all([
    fork(getScopesSaga),
    fork(createScopeSaga),
    fork(updateScopeSaga),
    fork(deleteScopeSaga),
  ]);
}
